import type { TradeConfirmationStateMap } from './tradeConfirm.model';
import { initialTradeConfirmationState } from './tradeConfirm.model';

export function getTradeConfirmation(state: TradeConfirmationStateMap, quoteId: string | undefined) {
  if (quoteId === undefined) {
    return initialTradeConfirmationState;
  }
  return state[quoteId] ?? initialTradeConfirmationState;
}
